<template>
  <div id="home">
    <div class="header">
      <img src="../../assets/img/index/bg_yunduan_home.png" alt class="bg" />
      <div class="top dl_center">
        <img
          src="../../assets/img/index/home_ico_fenxianghaoyou.png"
          alt
          class="file dl_margin3_top wx_lf"
          @click="InviteFriends()"
        />
        <div class="title dl_margin2_top">{{ $t("云端钱包") }}</div>
        <!-- <ul class="title dl_margin2_top">
          <li v-for="(item, index) in list" @click="toggle(index)" :class="{ 'is_active': index == active }"
            :key="index">{{ $t(item) }}</li>
        </ul> -->
        <img
          src="../../assets/img/index/home_ico_gengduo.png"
          alt
          class="cata dl_margin3_top wx_rt"
          @click="share()"
        />
      </div>
      <p class="asset wx_fontSize1">{{ $t("总资产") }}</p>

      <p class="amount wx_fontSize5" v-if="active == 0 && coludAllAmount > 0">
        {{ currency_char }}{{ coludAllAmount | numFiltertwo }}
      </p>
      <p
        class="amount wx_fontSize5"
        v-else-if="active == 0 && coludAllAmount == '0.00'"
      >
        {{ currency_char }}{{ coludAllAmount }}
      </p>
      <p class="amount wx_fontSize5" v-else>
        {{ currency_char }}{{ HdAllAmount }}
      </p>
      <img
        src="../../assets/img/index/home_ico_tianjia.png"
        alt
        class="add"
        @click="search()"
        ref="searched"
      />
      <!-- nff导入以及接收地址 -->
      <div class="nftsend" v-show="!coinshow">
        <div class="nftsendleft" @click="$router.push('/addnft')">
          <img
            src="../../assets/img/home/nftsend.png"
            style="width: 20px; height: 20px; margin-right: 10px"
          />
          <span>{{ $t("导入NFT") }}</span>
        </div>
        <div class="nftborder"></div>
        <div class="nftsendright" @click="$router.push('/nftaddress')">
          <img
            src="../../assets/img/home/nftaddress.png"
            style="width: 20px; height: 20px; margin-right: 10px"
          />
          <span>{{ $t("接收地址") }}</span>
        </div>
      </div>
    </div>
    <!-- nft和钱包切换选项 -->
    <div class="main">
      <div class="mainleft">
        <span @click="changecoin" :class="[coinshow ? 'borderbue' : '']">
          {{ $t("币种") }}</span
        >
      </div>
      <div class="mainright">
        <span @click="changenft" :class="[coinshow ? '' : 'borderbue']"
          >NFT</span
        >
        <div v-if="!coinshow">
          <!-- <img
            src="../../assets/img/home/nftcollect.png"
            style="width: 20px"
            @click="$router.push('/addnft')"
          /> -->
          <img
            src="../../assets/img/home/nfthistory.png"
            style="width: 20px; margin-left: 8px"
            @click="$router.push('/nfthistory')"
          />
        </div>
        <!-- <div>
          <img
            src="../../assets/img/home/3.1收藏@2x.png"
            style="width: 20px; margin-right: 7px"
            v-if="!coinshow"
          />
          <img
            src="../../assets/img/home/矢量智能对象@2x.png"
            style="width: 20px"
          />
        </div> -->
      </div>
    </div>
    <!-- 云端币种钱包列表 -->
    <div class="content" style="display: block" v-if="coinshow">
      <mt-loadmore
        :top-method="loadTop"
        :bottom-all-loaded="allLoaded"
        :autoFill="autoFill"
        :topPullText="$t('下拉刷新')"
        :topDropText="$t('')"
        topLoadingText=""
        ref="loadmore"
      >
        <!--云端钱包币种详情 -->
        <dl class="content_detail">
          <template v-for="(items, index) in CloudList">
            <dt class="caption" v-if="items.length > 0">
              <div>{{ $t(index) }}</div>
              <a v-if="index == 'BTC公链'" href="https://btc.com/">
                <svg
                  t="1647243848883"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2194"
                  width="16"
                  height="16"
                >
                  <path
                    d="M928.00032 512a95.68 95.68 0 0 0-32.256 5.952l-145.376-218.08A111.04 111.04 0 0 0 768.00032 240a112 112 0 1 0-224 0c0 28.288 10.848 53.856 28.16 73.568l-146.528 268.64A157.024 157.024 0 0 0 384.00032 576c-31.808 0-61.344 9.6-86.272 25.664l-117.344-140.8C187.55232 447.424 192.00032 432.32 192.00032 416a96 96 0 1 0-58.624 88.448l118.208 141.856A159.328 159.328 0 0 0 224.00032 736c0 88.224 71.776 160 160 160s160-71.776 160-160c0-50.784-24.224-95.584-61.248-124.896l143.744-263.52c9.472 2.592 19.232 4.416 29.504 4.416 16.288 0 31.648-3.648 45.6-9.888l144.416 216.608A95.04 95.04 0 0 0 832.00032 608a96 96 0 1 0 96-96zM384.00032 832c-52.928 0-96-43.072-96-96s43.072-96 96-96 96 43.072 96 96-43.072 96-96 96z"
                    p-id="2195"
                    fill="#1980d6"
                  /></svg
                >View Explorer
              </a>
              <a v-else-if="index == 'ETH公链'" href="https://etherscan.io/">
                <svg
                  t="1647243848883"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2194"
                  width="16"
                  height="16"
                >
                  <path
                    d="M928.00032 512a95.68 95.68 0 0 0-32.256 5.952l-145.376-218.08A111.04 111.04 0 0 0 768.00032 240a112 112 0 1 0-224 0c0 28.288 10.848 53.856 28.16 73.568l-146.528 268.64A157.024 157.024 0 0 0 384.00032 576c-31.808 0-61.344 9.6-86.272 25.664l-117.344-140.8C187.55232 447.424 192.00032 432.32 192.00032 416a96 96 0 1 0-58.624 88.448l118.208 141.856A159.328 159.328 0 0 0 224.00032 736c0 88.224 71.776 160 160 160s160-71.776 160-160c0-50.784-24.224-95.584-61.248-124.896l143.744-263.52c9.472 2.592 19.232 4.416 29.504 4.416 16.288 0 31.648-3.648 45.6-9.888l144.416 216.608A95.04 95.04 0 0 0 832.00032 608a96 96 0 1 0 96-96zM384.00032 832c-52.928 0-96-43.072-96-96s43.072-96 96-96 96 43.072 96 96-43.072 96-96 96z"
                    p-id="2195"
                    fill="#1980d6"
                  /></svg
                >View Explorer
              </a>
              <a v-else-if="index == 'HMC20'" href="http://www.hammerchain.io/">
                <svg
                  t="1647243848883"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2194"
                  width="16"
                  height="16"
                >
                  <path
                    d="M928.00032 512a95.68 95.68 0 0 0-32.256 5.952l-145.376-218.08A111.04 111.04 0 0 0 768.00032 240a112 112 0 1 0-224 0c0 28.288 10.848 53.856 28.16 73.568l-146.528 268.64A157.024 157.024 0 0 0 384.00032 576c-31.808 0-61.344 9.6-86.272 25.664l-117.344-140.8C187.55232 447.424 192.00032 432.32 192.00032 416a96 96 0 1 0-58.624 88.448l118.208 141.856A159.328 159.328 0 0 0 224.00032 736c0 88.224 71.776 160 160 160s160-71.776 160-160c0-50.784-24.224-95.584-61.248-124.896l143.744-263.52c9.472 2.592 19.232 4.416 29.504 4.416 16.288 0 31.648-3.648 45.6-9.888l144.416 216.608A95.04 95.04 0 0 0 832.00032 608a96 96 0 1 0 96-96zM384.00032 832c-52.928 0-96-43.072-96-96s43.072-96 96-96 96 43.072 96 96-43.072 96-96 96z"
                    p-id="2195"
                    fill="#1980d6"
                  /></svg
                >View Explorer
              </a>
            </dt>
            <dd
              v-for="item in items"
              @click="
                CoinPurse(
                  item.id,
                  item.coin_symbol,
                  item.cloud_balance,
                  item.img_url,
                  '云端',
                  item.display_coin_symbol
                )
              "
              :key="item.id"
            >
              <img v-bind:src="item.img_url" alt class="oImg" />
              <div class="amount_of wx_lt">
                <span class="currency_name">{{
                  item.display_coin_symbol
                }}</span>
                <span class="is_game" v-if="item.chain_game_id > 0">GAME</span>
                <span class="locked_desc"
                  >{{ $t("锁定") }}:{{ item.locked_balance }}</span
                >
              </div>
              <!-- <div class="amount_of wx_ct">
                <span class="locked_desc"
                  >{{ $t("锁定") }}:{{ item.locked_balance }}</span
                >
              </div> -->
              <div class="amount_of wx_rt">
                <p class="count wx_fontSize3">
                  {{ item.total_balance }}
                </p>
                <p class="money wx_fontSize2">
                  {{ item.currency_symbol }}{{ item.price }}
                </p>
              </div>
            </dd>
          </template>
        </dl>
      </mt-loadmore>
    </div>
    <!-- nft钱包展示 -->
    <div v-else class="nftcoin">
      <mt-loadmore
        :top-method="loadnft"
        :bottom-all-loaded="allLoaded"
        :autoFill="autoFill"
        :topPullText="$t('下拉刷新')"
        :topDropText="$t('')"
        topLoadingText=""
        ref="loadmore2"
      >
        <!-- 有数据显示nft -->
        <div v-if="nftlist.length">
          <div class="nftbox" v-for="(item, index) in nftlist" :key="index">
            <div class="nftheader">
              <div class="headerleft">
                <span>{{ item.title }}</span>
                <img
                  src="../../assets/img/home/nftdelete.png"
                  @click="nftdel(item.title, index)"
                />
              </div>
              <img
                v-if="item.nfticonshow == false"
                src="../../assets/img/home/下拉 拷贝@2x.png"
                style="width: 20px"
                @click="item.nfticonshow = true"
              />
              <img
                src="../../assets/img/home/下拉@2x.png"
                style="width: 20px"
                v-else
                @click="item.nfticonshow = false"
              />
            </div>
            <div class="nftcontent" v-if="item.nfticonshow == true">
              <!-- <div
                class="nftdetail"
                @click="shownftdetail(item)"
                v-for="(item, index) in nft"
                :key="item.id"
              >
                <img :src="item.image" style="width: 100%" />
                <span>{{ item.name }}</span>
                <span>编号:{{ item.tokenid }}</span>
              </div> -->
              <div class="nftcontentbox">
                <div
                  v-for="(item2, index2) in item.child"
                  :key="item2.id"
                  class="nftboxdetail"
                  @click="shownftdetail(item2, index, index2)"
                >
                  <img
                    :src="item2.image"
                    style="width: 100%; height: 80px; object-fit: contain"
                  />
                  <span>{{ item2.name }}</span>
                  <span>{{ $t("编号") }}:{{ item2.tokenid }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 无数据显示图片· -->
        <div v-else class="nonft">
          <div>{{ $t("暂无NFT收藏") }}</div>
        </div>
        <div class="addnft" @click="doaddnft">{{ $t("添加收藏品") }}</div>
      </mt-loadmore>
    </div>
    <div class="content local">
      <mt-loadmore
        :top-method="loadTopLocal"
        :bottom-all-loaded="allLoaded"
        :autoFill="autoFill"
        :topPullText="$t('')"
        :topDropText="$t('')"
        ref="loadmoreLocal"
      >
        <dl class="content_detail" ref="contentDetail">
          <template v-for="(items, index) in LocalList">
            <dt class="caption" v-if="items.length > 0">
              <div>{{ index }}</div>
              <a v-if="index == 'BTC'" href="https://btc.com/">
                <svg
                  t="1647243848883"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2194"
                  width="16"
                  height="16"
                >
                  <path
                    d="M928.00032 512a95.68 95.68 0 0 0-32.256 5.952l-145.376-218.08A111.04 111.04 0 0 0 768.00032 240a112 112 0 1 0-224 0c0 28.288 10.848 53.856 28.16 73.568l-146.528 268.64A157.024 157.024 0 0 0 384.00032 576c-31.808 0-61.344 9.6-86.272 25.664l-117.344-140.8C187.55232 447.424 192.00032 432.32 192.00032 416a96 96 0 1 0-58.624 88.448l118.208 141.856A159.328 159.328 0 0 0 224.00032 736c0 88.224 71.776 160 160 160s160-71.776 160-160c0-50.784-24.224-95.584-61.248-124.896l143.744-263.52c9.472 2.592 19.232 4.416 29.504 4.416 16.288 0 31.648-3.648 45.6-9.888l144.416 216.608A95.04 95.04 0 0 0 832.00032 608a96 96 0 1 0 96-96zM384.00032 832c-52.928 0-96-43.072-96-96s43.072-96 96-96 96 43.072 96 96-43.072 96-96 96z"
                    p-id="2195"
                    fill="#1980d6"
                  /></svg
                >View Explorer
              </a>
              <a v-else-if="index == 'ETH'" href="https://etherscan.io/">
                <svg
                  t="1647243848883"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2194"
                  width="16"
                  height="16"
                >
                  <path
                    d="M928.00032 512a95.68 95.68 0 0 0-32.256 5.952l-145.376-218.08A111.04 111.04 0 0 0 768.00032 240a112 112 0 1 0-224 0c0 28.288 10.848 53.856 28.16 73.568l-146.528 268.64A157.024 157.024 0 0 0 384.00032 576c-31.808 0-61.344 9.6-86.272 25.664l-117.344-140.8C187.55232 447.424 192.00032 432.32 192.00032 416a96 96 0 1 0-58.624 88.448l118.208 141.856A159.328 159.328 0 0 0 224.00032 736c0 88.224 71.776 160 160 160s160-71.776 160-160c0-50.784-24.224-95.584-61.248-124.896l143.744-263.52c9.472 2.592 19.232 4.416 29.504 4.416 16.288 0 31.648-3.648 45.6-9.888l144.416 216.608A95.04 95.04 0 0 0 832.00032 608a96 96 0 1 0 96-96zM384.00032 832c-52.928 0-96-43.072-96-96s43.072-96 96-96 96 43.072 96 96-43.072 96-96 96z"
                    p-id="2195"
                    fill="#1980d6"
                  /></svg
                >View Explorer
              </a>
              <a v-else-if="index == 'HMC'" href="http://www.hammerchain.io/">
                <svg
                  t="1647243848883"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2194"
                  width="16"
                  height="16"
                >
                  <path
                    d="M928.00032 512a95.68 95.68 0 0 0-32.256 5.952l-145.376-218.08A111.04 111.04 0 0 0 768.00032 240a112 112 0 1 0-224 0c0 28.288 10.848 53.856 28.16 73.568l-146.528 268.64A157.024 157.024 0 0 0 384.00032 576c-31.808 0-61.344 9.6-86.272 25.664l-117.344-140.8C187.55232 447.424 192.00032 432.32 192.00032 416a96 96 0 1 0-58.624 88.448l118.208 141.856A159.328 159.328 0 0 0 224.00032 736c0 88.224 71.776 160 160 160s160-71.776 160-160c0-50.784-24.224-95.584-61.248-124.896l143.744-263.52c9.472 2.592 19.232 4.416 29.504 4.416 16.288 0 31.648-3.648 45.6-9.888l144.416 216.608A95.04 95.04 0 0 0 832.00032 608a96 96 0 1 0 96-96zM384.00032 832c-52.928 0-96-43.072-96-96s43.072-96 96-96 96 43.072 96 96-43.072 96-96 96z"
                    p-id="2195"
                    fill="#1980d6"
                  /></svg
                >View Explorer
              </a>
            </dt>
            <dd
              v-for="item in items"
              @click="
                CoinPurse(
                  item.symbolId,
                  item.coinSymbol,
                  item.chainName,
                  item.coinIcon,
                  'HD',
                  item.coinDisplaySymbol
                )
              "
              :key="item.id"
            >
              <img v-bind:src="baseUrl + item.coinIcon" alt class="oImg" />
              <div class="amount_of wx_lt">
                <span class="currency_name">{{ item.coinDisplaySymbol }}</span>
                <!-- <span class="locked_desc">{{ $t('锁定') }}:{{ item.balance | numFilter }}</span> -->
              </div>
              <div class="amount_of wx_rt">
                <p class="count wx_fontSize3">{{ item.balance }}</p>
                <p class="money wx_fontSize2">$ {{ item.coinPrice }}</p>
              </div>
            </dd>
          </template>
        </dl>
      </mt-loadmore>
      <div class="contented" ref="contented">
        <div class="main_hd">
          <p class="wx_fontSize4 title_wallet">{{ $t("HD钱包") }}</p>
          <div class="top_main">
            <img src="@/assets/img/login_ico_siyao_bendi.png" alt />
            <span class="wx_fontSize2">{{
              $t("100%掌管私钥，资产更放心")
            }}</span>
          </div>
          <div class="top_main">
            <img src="@/assets/img/login_ico_daoru_bendi.png" alt />
            <span class="wx_fontSize2">{{
              $t("一键导入助记词，方便好用")
            }}</span>
          </div>
          <div class="top_main">
            <img src="@/assets/img/login_ico_daibi_bendi.png" alt />
            <span class="wx_fontSize2">{{
              $t("支持超过30+主流币和500+代币")
            }}</span>
          </div>
        </div>
        <div class="button">
          <div class="resgiter wx_lf" @click="createPay()">
            <div class="zhuce-btn bg-blue">{{ $t("创建钱包") }}</div>
          </div>
          <div class="login wx_rt" @click="goPin('钱包')">
            <div class="zhuce-btn bg-blue">{{ $t("导入钱包") }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="triangle" v-show="show">
      <div class="triangle_border_up">
        <span></span>
      </div>
    </div>

    <!-- 右侧地址簿弹框 -->
    <ul class="share" v-show="show" ref="cloud">
      <li @click="$router.push('/setlanguage')">
        <svg
          t="1640658195311"
          class="mark"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3507"
          width="25"
          height="25"
        >
          <path
            d="M848.804 805.57c70.999-81.259 109.778-184.212 109.778-293.14 0-119.204-46.418-231.275-130.714-315.566C744.873 113.869 634.936 67.62 517.786 66.217c-1.926-0.6-10.292-0.594-12.232 0.015-116.68 1.716-226.125 47.929-308.823 130.632-82.872 82.872-129.106 192.599-130.642 309.555-0.43 1.649-0.435 8.607-0.02 10.225 1.08 117.632 47.365 228.06 130.662 311.362 84.29 84.291 196.362 130.709 315.571 130.709 119.204 0 231.276-46.418 315.571-130.709a460.278 460.278 0 0 0 17.787-18.877 20.541 20.541 0 0 0 1.475-1.439 21.495 21.495 0 0 0 1.669-2.12zM107.448 532.046h187.505c1.32 65.674 9.252 127.263 22.507 182.108-61.69 16.691-100.817 38.374-121.077 51.907-52.07-64.728-84.706-145.705-88.935-234.015z m88.433-272.635c20.09 13.558 59.243 35.461 121.339 52.265-12.995 54.123-20.823 114.775-22.241 179.43H107.525c4.552-87.373 36.91-167.49 88.356-231.695zM917.079 491.1H729.631c-1.413-64.63-9.242-125.26-22.231-179.374 61.957-16.691 101.232-38.446 121.564-52.02 51.307 64.154 83.574 144.16 88.115 231.394z m-228.398 0H532.173V335.058c52.203-1.096 97.1-6.451 135.27-14.034 12.56 52.142 19.84 109.87 21.238 170.076zM532.168 294.113V109.921c36.838 10.399 72.78 49.203 100.925 110.014 8.812 19.036 16.645 39.639 23.465 61.522-35.026 6.768-76.298 11.607-124.39 12.656z m-40.945-183.838v183.802c-47.503-1.126-88.381-6-123.12-12.805 6.804-21.81 14.617-42.357 23.408-61.342 27.843-60.14 63.299-98.755 99.712-109.655z m0 224.768V491.1H335.928c1.388-60.216 8.679-117.954 21.243-170.102 37.837 7.537 82.314 12.887 134.052 14.045z m-155.33 197.002h155.33v158.663c-51.61 1.193-96.02 6.564-133.821 14.106-12.826-52.884-20.209-111.57-21.51-172.77z m155.33 199.623V914.58c-36.413-10.9-71.875-49.515-99.712-109.66-8.678-18.75-16.41-39.03-23.158-60.549 34.642-6.727 75.418-11.55 122.87-12.703z m40.945 183.27V731.608c47.897 1.024 89.098 5.862 124.114 12.657-6.754 21.555-14.495 41.876-23.189 60.656-28.145 60.81-64.082 99.62-100.925 110.019z m0-224.276V532.05h156.544c-1.3 61.097-8.658 119.685-21.443 172.498-38.113-7.532-82.949-12.836-135.101-13.886zM729.66 532.045h187.5c-4.219 88.135-36.73 168.975-88.622 233.636-20.47-13.67-59.633-35.303-121.303-51.871 13.204-54.758 21.104-116.224 22.425-181.765z m71.86-303.304c-18.33 11.571-52.311 29.358-104.858 43.495-19.297-63.053-46.11-115-78.06-150.974 70.395 19.149 133.233 56.837 182.918 107.48zM406.006 121.262c-31.903 35.922-58.69 87.772-77.978 150.702-52.403-14.244-86.37-32.102-104.581-43.586 49.628-50.463 112.333-88.013 182.559-107.116zM223.918 796.964c18.284-11.536 52.096-29.235 104.33-43.336 19.272 62.602 45.973 114.186 77.758 149.965-70.006-19.041-132.531-56.412-182.088-106.63z m394.68 106.629c31.8-35.804 58.517-87.424 77.789-150.083 51.983 14.024 85.975 31.632 104.535 43.203-49.593 50.345-112.2 87.808-182.324 106.88z"
            p-id="3508"
            fill="rgb(169, 175, 200)"
          />
        </svg>
        <span class="wx_fontSize3">{{ $t("默认语言") }}</span>
      </li>
      <li @click="InviteFriends()">
        <img
          src="../../assets/img/ico_yaoqing_tanjkuang.png"
          alt
          class="mark"
        />
        <span class="wx_fontSize3">{{ $t("邀请好友") }}</span>
      </li>
      <li @click="sendEnvelope()">
        <img
          src="../../assets/img/ico_hongbao_tanjkuang.png"
          alt
          class="mark"
        />
        <span class="wx_fontSize3">{{ $t("发红包") }}</span>
      </li>
      <li @click="against()">
        <img
          src="../../assets/img/ico_shandui_tanjkuang.png"
          alt
          class="mark"
        />
        <span class="wx_fontSize3">{{ $t("闪兑") }}</span>
      </li>
      <!-- <li @click="Flicking()">
        <img src="../../assets/img/ico_saoyisao_tanjkuang.png" alt class="mark" />
        <span class="wx_fontSize3">{{ $t('扫一扫') }}</span>
      </li> -->
      <li @click="addressBook('云端钱包地址簿')">
        <img src="../../assets/img/ico_dizhi_tanjkuang.png" alt class="mark" />
        <span class="wx_fontSize3">{{ $t("地址簿") }}</span>
      </li>
      <li @click="historyNotice('云端钱包公告')">
        <img
          src="../../assets/img/ico_tongzhi_tanjkuang.png"
          alt
          class="mark"
        />
        <span class="wx_fontSize3">{{ $t("历史公告") }}</span>
      </li>
      <li style="border: 0" @click="setUp()">
        <img src="../../assets/img/ico_shezhi_tanjkuang.png" alt class="mark" />
        <span class="wx_fontSize3">{{ $t("设置") }}</span>
      </li>
    </ul>
    <div class="triangle" v-show="isShow">
      <div class="triangle_border_up">
        <span></span>
      </div>
    </div>
    <ul class="share" v-show="isShow" ref="HD">
      <li @click="goPin('助记词')">
        <img
          src="../../assets/img/ico_chakani_tanjkuang.png"
          alt
          class="mark"
        />
        <span class="wx_fontSize2">{{
          is_backup ? $t("查看助记词") : $t("备份助记词")
        }}</span>
      </li>
      <li @click="goPin('钱包')">
        <img
          src="../../assets/img/ico_daoruqianbao_tanjkuang.png"
          alt
          class="mark"
        />
        <span class="wx_fontSize3">{{ $t("导入钱包") }}</span>
      </li>
      <li @click="addressBook('HD钱包地址簿')">
        <img src="../../assets/img/ico_dizhi_tanjkuang.png" alt class="mark" />
        <span class="wx_fontSize3">{{ $t("地址簿") }}</span>
      </li>
      <li @click="historyNotice('HD钱包公告')">
        <img
          src="../../assets/img/ico_tongzhi_tanjkuang.png"
          alt
          class="mark"
        />
        <span class="wx_fontSize3">{{ $t("历史公告") }}</span>
      </li>
    </ul>
    <!-- nft详情弹框内容 -->
    <mt-popup v-model="popupshow">
      <div class="nftshow" v-if="Object.keys(nftpop).length > 0">
        <div class="nftimg">
          <img
            :src="nftpop.image"
            style="width: 100%; object-fit: cover; height: 300px"
          />
        </div>
        <div style="font-size: 15px; margin-bottom: 8px">
          {{ nftpop.name }}
        </div>
        <div style="font-size: 10px; margin-bottom: 8px; color: #7b7a8a">
          {{ $t("编号") }}: {{ nftpop.tokenid }}
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
          "
        >
          <span class="nftcopy"> {{ nftpop.contract }}</span>
          <img
            src="../../assets/img/home/copy.png"
            style="width: 12px; height: 12px"
            @click="nftcopy($event, nftpop.contract)"
          />
        </div>
        <div class="nftbtn">
          <button
            @click="dodelnft(nftpop.id)"
            style="
              flex: 1;
              object-fit: contain;
              margin: 0 auto;
              display: block;
              padding: 10px;
              color: #252525;
              background-color: #f6f6f6;
              margin-right: 4px;
            "
          >
            {{ $t("删除") }}
          </button>
          <button
            style="
              flex: 1;
              object-fit: contain;
              margin-left: 4px;
              display: block;
              padding: 10px;
              background-color: #4492d4;
              color: #ffff;
            "
            @click="$router.push({ path: '/outnft', query: nftpop })"
          >
            {{ $t("转出") }}
          </button>
        </div>
      </div>
    </mt-popup>
    <!-- 删除弹框提示样式 -->
    <mt-popup v-model="nftdelshow">
      <div class="delbox">
        <div class="deltitle" v-if="isallnft">{{ $t("确认删除此专辑吗") }}</div>
        <div class="deltitle" v-else>{{ $t("确认删除此收藏品吗") }}</div>
        <div class="delbtn">
          <button
            style="
              margin-right: 10px;
              width: 120px;
              padding: 12px 0;
              background-color: #f6f6f6;
              border-radius: 2px;
            "
            @click="nftdelshow = false"
          >
            {{ $t("取消") }}
          </button>
          <button
            style="
              margin-left: 10px;
              width: 120px;
              padding: 12px 0;
              background: #4492d4;
              border-radius: 2px;
              color: #ffff;
            "
            @click="allnftdel"
            :disabled="btnstatus == false"
          >
            {{ $t("确认") }}
          </button>
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
import { Toast, Popup } from "mint-ui";
import {
  saoYiSaoMessage,
  createUniqueString,
  parseTime,
  getAppValue,
} from "@/utils/index";
import handleClipboard from "@/utils/clipboard";
import { validateEmpty } from "@/utils/validate";
import { httpCloudLists, httpNoticeLists } from "@/api/index";
import { delAlbum, delCollection, getallCollection } from "../../api/nft";
import httpConfig from "@/api/httpConfig";
import { httpChainList, httpList, httpCreate, httpInit } from "@/api/hdwallet";
import { numFilter, numFiltertwo } from "../../filters/index";

export default {
  data: function () {
    return {
      baseUrl: httpConfig.baseHDURL,
      list: ["云端钱包", "HD钱包"],
      active: 0,
      coinshow: true,
      popupshow: false,
      nftdelshow: false,
      show: false,
      isShow: false,
      is_backup: false, //是否备份助记词的参数
      jumpAddrs: "", //判断是点击助记词还是钱包
      getValue: "",
      CloudList: [],
      currentView: "", //向父组件要传的值
      allLoaded: false,
      autoFill: false,
      LocalList: [],
      noticeList: {},
      currency: "",
      currency_char: "",
      currency_usd_rate: "",
      coludAllAmount: 0,
      HdAllAmount: 0,
      nftlist: [],
      nftdetail: [],
      nftpop: {},
      isallnft: false,
      nftid: "",
      nftname: "",
      btnstatus: true,
      nftindex: {}, //收藏索引
      albumindex: -1, //记录删除专辑索引
    };
  },
  created() {},
  mounted: function () {
    this.noticeLists();
  },
  activated() {
    this.getNFT();
    this.token = this.$store.getters.token;
    if (validateEmpty(this.token)) {
      this.$router.replace("/index/nologin");
      return;
    }
    this.show = false;
    this.isShow = false;
    this.nftid = "";
    this.nftname = "";
    this.isallnft = false;
    this.nftindex = {};
    this.albumindex = -1;
    if (this.$route.query.result) {
      if (this.jumpAddrs == "助记词") {
        if (!this.is_backup) {
          this.$router.push("/backup");
        } else {
          this.$router.push("/lookWords");
        }
      } else if (this.jumpAddrs == "钱包") {
        this.$router.push("/selectWords");
      }
    }
    this.currency_char = this.$store.state.currency_char;
    this.currency_usd_rate = this.$store.state.currency_usd_rate;

    if (this.active == 1 && this.LocalList.length == 0) {
      if (validateEmpty(this.$store.state.hdtoken)) {
        this.$refs.contented.style.display = "block";
        this.$refs.contentDetail.style.display = "none";
        this.$refs.searched.style.display = "none";
      } else {
        this.$refs.contented.style.display = "none";
        this.$refs.contentDetail.style.display = "block";
        this.$refs.searched.style.display = "block";
        this.getLocalData();
      }
    } else if (this.active == 0) {
      this.$refs.contented.style.display = "none";
      this.$refs.contentDetail.style.display = "block";
      this.$refs.searched.style.display = "block";
      this.getData();
    }
    window.getvalueFromApp = this.getvalueFromApp;
  },
  methods: {
    loadTop() {
      this.getData();
    },
    loadTopLocal() {
      this.getLocalData();
    },
    //加载nft钱包
    loadnft() {
      this.getNFT();
      this.$refs.loadmore2.onTopLoaded();
    },
    //币种和nft切换
    changenft() {
      if (this.coinshow) {
        this.coinshow = false;
        //this.getNFT();
      }
    },
    changecoin() {
      this.coinshow = true;
    },
    //删除专辑
    nftdel(name, index) {
      this.isallnft = true;
      this.nftdelshow = true;
      this.nftname = name;
      this.albumindex = index;
    },
    //删除藏品  唤起提示弹框
    dodelnft(id) {
      this.nftid = id;
      this.isallnft = false;
      this.popupshow = false;
      this.nftdelshow = true;
    },
    allnftdel() {
      this.btnstatus = false;
      //删除在此判断
      if (this.isallnft) {
        //删除专辑
        delAlbum({ name: this.nftname })
          .then((res) => {
            if (res.code == 1) {
              this.nftdelshow = false;
              this.btnstatus = true;
              Toast(this.$t("删除成功"));
              //重新获取数据
              this.nftlist.splice(this.albumindex, 1);
              //this.getNFT();
            }
          })
          .catch(() => {
            this.btnstatus = true;
          });
      } else {
        //删除单个藏品
        delCollection({ id: this.nftid })
          .then((res) => {
            if (res.code == 1) {
              this.nftdelshow = false;
              this.popupshow = false;
              Toast(this.$t("删除成功"));
              this.btnstatus = true;
              //删除成功  本地数据删除
              this.nftlist[this.nftindex.first].child.splice(
                this.nftindex.second,
                1
              );
              //最后一个删除专辑
              if (this.nftlist[this.nftindex.first].child.length <= 0) {
                this.nftlist.splice(this.nftindex.first, 1);
              }
            }
          })
          .catch(() => {
            this.btnstatus = true;
          });
      }
    },

    //nft详情弹框赋值 记录删除位置
    shownftdetail(item, index, index2) {
      this.nftindex.first = index;
      this.nftindex.second = index2;
      this.nftpop = item;
      this.popupshow = true;
    },
    //nft复制
    nftcopy(event, val) {
      handleClipboard(
        val,
        event,
        () => {
          Toast(this.$t("fuzhicg"));
        },
        () => {
          Toast(this.$t("fuzhicc"));
        }
      );
    },
    doaddnft() {
      this.$router.push("/addnft");
    },

    //nft列表请求
    getNFT: function () {
      this.nftlist = [];
      getallCollection()
        .then((res) => {
          res.data.forEach((item) => {
            item.nfticonshow = false;
          });
          this.nftlist = res.data;
        })
        .catch(() => {});
    },
    //首页币种列表
    getData: function () {
      httpCloudLists({ currency: this.$store.getters.currency })
        .then((res) => {
          this.coludAllAmount = 0;
          const list = {};

          res.data.list.forEach((item) => {
            this.coludAllAmount += Number(item.price);
            if (Array.isArray(list[item.group_tag])) {
              list[item.group_tag].push(item);
            } else {
              list[item.group_tag] = [item];
            }
          });
          this.CloudList = list;
          if (this.coludAllAmount == 0) {
            this.coludAllAmount = "0.00";
          }
          this.$refs.loadmore.onTopLoaded();
        })
        .catch(() => {
          this.$refs.loadmore.onTopLoaded();
        });
    },
    getLocalData: async function () {
      let localeList = [],
        list = {};
      this.HdAllAmount = 0;

      const { result: chanList } = await httpChainList();
      for (let i = 0; i < chanList.length; i++) {
        let { result } = await httpList({
          chainId: chanList[i].id,
          pageNo: 0,
          pageSize: 10000,
        });
        /* if (result.page.records.length === 0) {
          httpInit({address: window.LS.get('btcAddress'), chainId: chanList[i].id})
          result = { result } = await httpList({ chainId: chanList[i].id, pageNo: 0, pageSize: 10000 })
        } */
        this.HdAllAmount += result.assetValuation;
        localeList = [...localeList, ...result.page.records];
      }
      for (let i = 0; i < localeList.length; i++) {
        if (Array.isArray(list[localeList[i].chainSymbol])) {
          list[localeList[i].chainSymbol].push(localeList[i]);
        } else {
          list[localeList[i].chainSymbol] = [localeList[i]];
        }
      }
      this.LocalList = list;
    },
    toggle(index) {
      this.active = index;
      var tabCardCollection = document.querySelectorAll(".content"),
        len = tabCardCollection.length;
      for (var i = 0; i < len; i++) {
        tabCardCollection[i].style.display = "none";
      }
      tabCardCollection[index].style.display = "block";
      if (index == 0) {
        document.querySelector(".file").style.display = "block";
        document.querySelector(".message").style.display = "block";
        this.isShow = false;
      } else if (index == 1) {
        document.querySelector(".file").style.display = "none";
        document.querySelector(".message").style.display = "none";
        this.show = false;
      }
      if (index == 1 && this.LocalList.length == 0) {
        if (validateEmpty(this.$store.state.hdtoken)) {
          this.$refs.contented.style.display = "block";
          this.$refs.contentDetail.style.display = "none";
          this.$refs.searched.style.display = "none";
        } else {
          this.$refs.contented.style.display = "none";
          this.$refs.contentDetail.style.display = "block";
          this.$refs.searched.style.display = "block";
          this.getLocalData();
        }
      } else {
        this.$refs.contented.style.display = "none";
        this.$refs.contentDetail.style.display = "block";
        this.$refs.searched.style.display = "block";
      }
    },
    hidden() {
      this.isShow = false;
      this.show = false;
    },
    share() {
      if (this.active == 0) {
        this.show = !this.show;
      } else if (this.active == 1) {
        this.isShow = !this.isShow;
      }
    },
    CoinPurse(id, title, price, img_url, category, displayCoinSymbol) {
      this.$router.push({
        path: "/CoinPurse",
        query: {
          id: id,
          title: title,
          price: price,
          img_url: img_url,
          category: category,
          display_coin_symbol: displayCoinSymbol,
        },
      });
    },
    InviteFriends() {
      this.$router.push("/share");
    },
    sendEnvelope() {
      this.$router.push("/sendEnvelope");
    },
    against() {
      this.$router.push("/against");
    },
    addressBook(title) {
      this.$router.push({ path: "/addressBook", query: { title: title } });
    },
    historyNotice(title) {
      this.$router.push({ path: "/historyNotice", query: { title: title } });
    },
    setUp() {
      this.$router.push("/setUp");
    },
    search() {
      if (this.active == 0) {
        this.$router.push("/search");
      } else {
        this.$router.push("/hDsearch");
      }
    },
    createPay() {
      this.$router.push("/mnemonicWord");
    },
    goPin: function (name) {
      this.jumpAddrs = name;
      // validateEmpty(this.$store.getters.Token)
      // if (!validateEmpty(this.$store.getters.pin)) {
      //   this.$router.push("/pincheck");
      // } else {
      if (this.jumpAddrs == "助记词") {
        if (!this.is_backup) {
          this.$router.push("/backup");
        } else {
          this.$router.push("/lookWords");
        }
      } else if (this.jumpAddrs == "钱包") {
        this.$router.push("/selectWords");
      }
      //}
    },
    Flicking() {
      saoYiSaoMessage();
    },
    getvalueFromApp(value) {
      this.getValue = value;
      let t = value.split(":");
      if (t.length != 2) {
        Toast(value);
      } else {
        this.$router.push({
          path: "/send",
          query: { coin_symbol: t[0], category: "云端", addr: t[1] },
        });
      }
    },
    noticeLists: function () {
      httpNoticeLists({ type: 1 })
        .then((res) => {
          this.noticeList = res.data.list[0];
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
#home {
  width: 100%;
  background: #f6f6f6;
  height: 100%;
}

.mint-loadmore {
  overflow: visible !important;
}

/*顶部*/
.header {
  width: 100%;
  height: 200px;
}

.header .bg {
  width: 100%;
  height: 100%;
}

.top {
  width: 100%;
  height: 48px;
  position: absolute;
  top: 0;
}

.file {
  width: 20px;
  height: 20px;
  margin-left: 15px;
}

.cata {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}

.title {
  width: calc(100% - 150px);
  height: 28px;
  color: #fff;
  border: 1px solid transparent;
  border-radius: 5px;
  position: absolute;
  left: 75px;
}

.title li {
  width: 50%;
  height: 100%;
  float: left;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 28px;
}

.title .is_active {
  background: #fff;
  color: #0191f5;
}

.asset {
  color: #fff;
  padding: 0 15px;
  position: absolute;
  top: 80px;
}

.amount {
  position: absolute;
  top: 100px;
  color: #fff;
  padding: 0 15px;
}

.add {
  width: 34px;
  height: 34px;
  position: absolute;
  right: 15px;
  top: 90px;
  visibility: hidden;
  opacity: 0;
}

.message {
  background: #fff;
  position: absolute;
  top: 160px;
  width: calc(100% - 20px);
  overflow: hidden;
  z-index: 1;
  margin: 5px 5px 5px 10px;
  border-radius: 10px;
  height: 100px;
  box-shadow: 2px 2px 2px #dcdcdc;
}

.Mes_title {
  width: 100%;
  height: 35px;
  line-height: 40px;
  color: #8c92a8;
  position: relative;
  margin-left: 12px;
  font-weight: 600;
}

.Mes_title img {
  position: absolute;
  left: -23px;
  top: 15px;
  width: 15px;
  height: 13px;
}

.Mes_main {
  color: #212529;
  padding: 0 12px;
  line-height: 18.5px;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 600;
}

.titme {
  width: 100%;
  padding: 0 12px;
  height: 40px;
  position: relative;
  line-height: 40px;
  color: #8c92a8;
}

.titme .detail {
  position: absolute;
  right: 30px;
}

.titme .detail a {
  color: #0191f5;
}

/*内容*/
.content {
  background: #f6f6f6;
  width: 100%;
  display: none;
  height: calc(100% - 260px);
  overflow: scroll;
  box-sizing: border-box;
  width: calc(100% - 10px);
}

.local {
  padding-top: 0;
}

.content_detail {
  margin-right: 0px;
}

.content_detail dt {
  padding-left: 10px;
  margin-top: 10px;
}

.content_detail dd {
  background: #fff;
  margin: 10px 0px 5px 10px;
  border-radius: 5px;
  box-shadow: 0px 1px 1px #eae8e8;
  position: relative;
}

.oImg {
  width: 40px;
  height: 40px;
  margin: 15px 14px 12px 14px;
  position: relative;
}

.amount_of {
  text-align: left;
  margin-right: 10px;
}

.wx_lt {
  position: absolute;
  left: 80px;
  top: 10px;
}

.wx_ct {
  position: absolute;
  left: 50%;
  top: 25px;
  font-size: 13px;
}

.is_game {
  font-size: 12px;
  margin-left: 4px;
  color: #167d3d;
  padding: 2px;
  background: rgba(88, 185, 124, 0.3);
  border: solid 1px #167d3d;
  width: 40px;
  text-align: center;
  margin-top: -10px;
}

.wx_ct {
  position: absolute;
  top: 20px;
  left: 200px;
}

.locked_desc {
  display: block;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #afafaf;
}

.wx_rt {
  position: absolute;
  right: 0;
  top: 0;
}

.count {
  color: #212529;
  padding: 10px 0;
  font-weight: bold;
  text-align: right;
}

.money {
  text-align: right;
  color: #afafaf;
  font-size: 13px;
}

/*分享*/
.share {
  position: absolute;
  background: #fff;
  top: 68px;
  right: 15px;
  border-radius: 6px;
  box-shadow: 0 0 20px rgba(5, 61, 109, 0.2);
  overflow: hidden;
  z-index: 2;
}

.share li {
  margin: 0 15px;
  padding: 15px 0;
  border-bottom: 1px solid #e3e8ed;
}

.mark {
  width: 20px;
  height: 20px;
  margin: 0 16px 0 5px;
  position: relative;
  top: 4px;
}

.triangle {
  position: absolute;
  top: 60px;
  left: 88%;
}

.triangle_border_up {
  width: 0;
  height: 0;
  border-width: 0 8px 8px;
  border-style: solid;
  border-color: transparent transparent #fff;
  /*透明 透明  灰*/
  position: relative;
}

/*HD内容*/
.contented {
  background: #f6f6f6;
  width: 80%;
  display: none;
  padding: 0 10%;
  display: none;
}

.main_hd {
  width: 100%;
  margin-top: 29px;
  box-shadow: 0 0 20px rgba(0, 119, 255, 0.2);
  background: #fff;
  padding-bottom: 20px;
}

.button {
  width: 100%;
  position: relative;
  height: 56px;
  margin-top: 35px;
}

.resgiter,
.login {
  width: 46%;
  height: 56px;
}

.resgiter {
  margin-right: 2%;
}

.login {
  margin-left: 2%;
}

.resgiter img,
.login img {
  width: 100%;
  height: 56px;
}

.title_wallet {
  width: 100%;
  text-align: center;
  color: #212529;
  padding-top: 20px;
}

.top_main {
  padding: 0 16px;
}

.top_main img {
  width: 20px;
  height: 20px;
  margin-top: 30px;
}

.top_main span {
  color: #8c92a8;
  position: relative;
  top: -5px;
  margin-left: 10px;
}

.zhuce-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
}

.bg-blue {
  background-color: #1980d6;
}

.bg-blue2 {
  background-color: #5351f1;
}

.caption {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.caption a {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #1980d6;
}

.caption svg {
  margin-right: 5px;
}
.currency_name {
  display: inline-block;
  margin-bottom: 10px;
}
.main {
  display: flex;
  align-items: center;
  padding: 10px 10px;
  height: 20px;
}
.mainleft {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei UI;
}
.mainleft span {
  padding-bottom: 3px;
}
.mainright {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei UI;
}
.mainright span {
  padding-bottom: 3px;
}
.borderbue {
  border-bottom: 2px solid #4184d2;
}
.nftcoin {
  padding: 0 10px;
  height: calc(100% - 260px);
  overflow: auto;
}
.nftheader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/.mint-loadmore-top span {
  display: none;
}

.nftdetail {
  display: flex;
  flex-direction: column;
  width: 23%;
  margin: 8px 2% 6px 0px;
}

.addnft {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #4184d2;
}
.headerleft {
  display: flex;
  align-items: center;
}
.headerleft span {
  font-size: 15px;
}
.headerleft img {
  width: 20px;
  margin-left: 5px;
}
.nonft {
  display: flex;
  align-items: end;
  justify-content: center;
  width: 50%;
  margin: 0 auto;
  height: 200px;
  background: url("../../assets/img/home/nonft.png") no-repeat center;
  background-size: contain;
  font-size: 15px;
  color: #7d7f98;
  margin-bottom: 20px;
}
.nftshow {
  width: 80vw;
  padding: 20px;
}
.nftcopy {
  display: block;
  font-size: 10px;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nftbox {
  margin-bottom: 20px;
}
.nftcontentbox {
  display: flex;
  overflow: auto;
  margin-top: 10px;
}
.nftboxdetail {
  width: 23%;
  margin: 0 5px;
  flex-shrink: 0;
}
.nftboxdetail span:nth-of-type(1) {
  display: block;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 5px;
}
.nftboxdetail span:nth-of-type(2) {
  font-size: 10px;
  color: #7b7a8a;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.delbox {
  width: 85vw;
  height: 175px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.deltitle {
  font-size: 15px;
  color: #64667a;
  margin-top: 40px;
}
.delbtn {
  margin-bottom: 35px;
}
.nftbtn {
  display: flex;
}
.nftsend {
  position: absolute;
  top: 150px;
}
.nftsend {
  width: 100vw;
  height: 50px;
  background-color: #7d7f98;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nftsendleft {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #fff;
}
.nftborder {
  height: 28px;
  width: 1px;
  background-color: #fff;
}
.nftsendright {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #fff;
}
</style>
